import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./heart+fill.svg"; export default path + "#$"